import React from 'react';
import { Link } from 'react-router-dom';

const EmployeeParking = () => (
  <div id="content">
    <div className="container-fluid bg-dark-steel-grey" id="vyc-hero-1">
      <div className="container">
        <div className="row content-block double-padding quadruple-padding">
          <div className="col-xs-10 col-xs-push-1 col-sm-12 col-sm-push-0 text-center">
            <img src="/static/images/business/icons-cta/cta-visit-your-clients@2x.png" alt="Visit Your Clients" id="icon-cta-visit-your-clients" />
            <h2 className="collapse-gap">Make It Easy To <strong>Visit Your Clients</strong></h2>
            <p className="callout">Save time and money by booking parking in advance</p>
          </div>
        </div>
      </div>
    </div>

    <div className="container-fluid bg-red">
      <div className="container">
        <div className="row content-block half-padding">
          <div className="text-center">
            <h2 className="collapse-gap capitalize">How It Benefits Your Business</h2>
          </div>
        </div>
      </div>
    </div>

    <div className="container-fluid bg-off-white equalizer-watch">
      <div className="container">
        <div className="row content-block">
          <div className="col-xs-10 col-xs-push-1">
            <div className="row">
              <div className="col-xs-12 col-sm-5 text-center equalizer">
                <img src="/static/images/business/icons/icon-piggy-bank@2x.png" alt="Piggy Bank" id="icon-piggy-bank" />
                <h4 className="red">Save Money</h4>
                <p>We've done the negotiating, but you'll reap the benefits. With rates often below drive up, you'll save your business money by buying through ParkWhiz.</p>
              </div>
              <div className="col-xs-12 col-sm-2 text-center">
                <hr className="equalizer" />
              </div>
              <div className="col-xs-12 col-sm-5 text-center equalizer">
                <img src="/static/images/business/icons/icon-list-document@2x.png" alt="List Icon" id="icon-list-document" />
                <h4 className="red">Save Time</h4>
                <p>Stop saving, scanning, and tracking paper receipts. All of your business transactions are stored in one place and accessible whenever you need them.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="container-fluid bg-white equalizer-watch">
      <div className="container">
        <div className="row content-block">
          <div className="col-xs-10 col-xs-push-1">
            <div className="row">
              <div className="col-xs-12 col-sm-5 text-center equalizer">
                <img src="/static/images/business/icons/icon-mobile-currency@2x.png" alt="Currency Icon" id="icon-mobile-currency" />
                <h4 className="red">Streamlined Payments</h4>
                <p>All employees under your company account can now charge parking directly to your business, reducing out-of-pocket expenses.</p>
              </div>
              <div className="col-xs-12 col-sm-2 text-center">
                <hr className="equalizer" />
              </div>
              <div className="col-xs-12 col-sm-5 text-center equalizer">
                <img src="/static/images/business/icons/icon-laptop-data@2x.png" alt="Laptop Icon" id="icon-laptop-data" />
                <h4 className="red">Real-Time Insights</h4>
                <p>How much are you paying for parking every month? Get insights into your parking expenses and start getting smart about your spending.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="container-fluid bg-red">
      <div className="container">
        <div className="row content-block half-padding">
          <div className="text-center">
            <h2 className="collapse-gap capitalize">How It Works</h2>
          </div>
        </div>
      </div>
    </div>

    <div className="container-fluid bg-dark-steel-grey" id="vyc-how-it-works">
      <div className="container">
        <div className="row content-block double-padding">
          <div className="col-xs-10 col-xs-push-1 col-sm-6 col-sm-push-3 text-center">
            <div className="row">
              <img src="/static/images/business/icons/icon-credit-card@2x.png" alt="" id="icon-credit-card" />
              <h2 className="red collapse-gap">Add Payment</h2>
              <p className="callout">Add a credit card for business charges and you're all set</p>
            </div>
            <div className="blue-link" />
            <div className="row">
              <img src="/static/images/business/icons/icon-add-user@2x.png" alt="" id="icon-add-user" />
              <h2 className="red collapse-gap">Add Employees</h2>
              <p className="callout">Add/remove employees individually or using our bulk upload tool. Have a large company? We can do it for you. Just ask.</p>
            </div>
            <div className="blue-link" />
            <div className="row">
              <img src="/static/images/business/icons/icon-mobile-check@2x.png" alt="" id="icon-mobile-check" />
              <h2 className="red collapse-gap">Book &amp; Park</h2>
              <p className="callout">With one click, your employees can start billing directly to your business using our website and our app. Expense memos are also available for tracking.</p>
            </div>
            <div className="blue-link" />
            <div className="row">
              <img src="/static/images/business/icons/icon-responsive-devices@2x.png" alt="" id="icon-responsive-devices" />
              <h2 className="red collapse-gap">Track &amp; Manage</h2>
              <p className="callout">ParkWhiz for Business gives you all the tools to easily manage your account and get the insights you need.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="container-fluid bg-off-white equalizer-watch">
      <div className="container">
        <div className="row content-block">
          <div className="col-xs-10 col-xs-push-1 text-center">
            <div className="row">
              <div className="col-xs-12 col-sm-6">
                <div className="rounded bg-white">
                  <div className="equalizer">
                    <img src="/static/images/business/icons-cta/cta-clients-visit-you@2x.png" id="icon-cta-clients-visit-you" alt="" />
                    <h3 className="blue">Have Clients Visit You</h3>
                    <p>Easily send clients reserved parking in advance</p>
                  </div>
                  <Link to={{ pathname: '/business/clients-visit-you' }} className="button">Learn More</Link>
                </div>
              </div>
              <div className="col-xs-12 col-sm-6">
                <div className="rounded bg-white">
                  <div className="equalizer">
                    <img src="/static/images/business/icons-cta/cta-faq@2x.png" id="icon-cta-faq" alt="" />
                    <h3 className="blue">Get All The FAQ<span className="lowercase">s</span></h3>
                    <p>Have more questions about our business solutions? We have answers.</p>
                  </div>
                  <Link to={{ pathname: '/business/faq' }} className="button">Visit FAQ<span className="lowercase">s</span></Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default EmployeeParking;
